import { routes as estoquePadrao } from '../merenda/estoquepadrao';
import { routes as medicaoIMC } from '../merenda/medicaoIMC';
import { routes as merAlmoxarifado } from '../merenda/meralmoxarifado';
import { routes as merBalanceamento } from '../merenda/merbalanceamento';
import { routes as merCardapio } from '../merenda/mercardapio';
import { routes as merCardapioDia } from '../merenda/mercardapiodia';
import { routes as merClassificacao } from '../merenda/merclassificacao';
import { routes as merContrato } from '../merenda/mercontrato';
import { routes as merDietaEspecial } from '../merenda/merdietaespecial';
import { routes as merEmbalagem } from '../merenda/merembalagem';
import { routes as merEscolaCardapio } from '../merenda/merescolacardapio';
import { routes as merFornecimento } from '../merenda/merfornecimento';
import { routes as merFornecimentoDireto } from '../merenda/merfornecimentodireto';
import { routes as merLevantamentoEstoqueCentral } from '../merenda/merlevantamentoestoquecentral';
import { routes as merLevantamentoEstoqueEscola } from '../merenda/merlevantamentoestoqueescola';
import { routes as merMaterial } from '../merenda/mermaterial';
import { routes as merMedicao } from '../merenda/mermedicao';
import { routes as merMotivoEstorno } from '../merenda/mermotivoestorno';
import { routes as merMovimentoEstoqueCentral } from '../merenda/mermovimentoestoquecentral';
import { routes as merMovimentoEstoqueEscola } from '../merenda/mermovimentoestoqueescola';
import { routes as merNecessidade } from '../merenda/mernecessidade';
import { routes as merPreparacao } from '../merenda/merpreparacao';
import { routes as merRefeicao } from '../merenda/merrefeicao';
import { routes as merRota } from '../merenda/merrota';
import { routes as merSolicitacaoCentral } from '../merenda/mersolicitacaocentral';
import { routes as merSolicitacaoEscola } from '../merenda/mersolicitacaoescola';
import { routes as merTacoClassificacao } from '../merenda/mertacoclassificacao';
import { routes as merTipoMaterial } from '../merenda/mertipomaterial';
import { routes as merTipoMovimento } from '../merenda/mertipomovimento';
import { routes as merTipoPerda } from '../merenda/mertipoperda';
import { routes as merTipoRefeicao } from '../merenda/mertiporefeicao';
import { routes as merUnidade } from '../merenda/merunidade';
import { routes as padraoEscola } from '../merenda/padraoescola';
import { routes as relatoriosIMC } from '../merenda/relatorios/IMC';
export default [
  {
    path: '/merenda',
    name: 'Merenda',
    description: 'Modulo Merenda',
    children: [
      ...merEmbalagem,
      ...merUnidade,
      ...merTipoRefeicao,
      ...merTipoMovimento,
      ...merTacoClassificacao,
      ...merTipoPerda,
      ...merClassificacao,
      ...merRota,
      ...merAlmoxarifado,
      ...merMaterial,
      ...merTipoMaterial,
      ...merMotivoEstorno,
      ...estoquePadrao,
      ...padraoEscola,
      ...medicaoIMC,
      ...relatoriosIMC,
      ...merMovimentoEstoqueEscola,
      ...merMovimentoEstoqueCentral,
      ...merLevantamentoEstoqueEscola,
      ...merLevantamentoEstoqueCentral,
      ...merContrato,
      ...merSolicitacaoEscola,
      ...merSolicitacaoCentral,
      ...merFornecimentoDireto,
      ...merFornecimento,
      ...merMedicao,
      ...merBalanceamento,
      ...merNecessidade,
      ...merDietaEspecial,
      ...merCardapio,
      ...merCardapioDia,
      ...merEscolaCardapio,
      ...merRefeicao,
      ...merPreparacao,
    ],
    goesToMenu: true,
  },
];
